<p-confirmDialog
	key="migrationConfirmation"
	appendTo="body"
	styleClass="migration-confirmation-dialog">
	<ng-template #message>
		<div class="migration-confirmation-content">
			<p class="migration-confirmation-description">
				Re-syncs the last year of invoices and tickets for the selected buyer, updating their statuses in
				NetSuite.
			</p>
			<p-select
				[options]="buyerOptions()"
				[ngModel]="selectedBuyer()"
				(ngModelChange)="selectedBuyer.set($event)"
				optionLabel="label"
				dataKey="name"
				placeholder="Select buyer"
				appendTo="body"
				[filter]="true"
				filterBy="label"
				class="w-full"></p-select>
		</div>
	</ng-template>
</p-confirmDialog>

<div class="admin-actions">
	<p-divider
		align="left"
		styleClass="admin-actions__divider">
		<span class="admin-actions__section-label">Sync from Open Invoice</span>
	</p-divider>

	<div class="admin-actions__list">
		<div class="admin-actions__row">
			<i class="pi pi-sitemap admin-actions__icon"></i>
			<div class="admin-actions__text">
				<span class="admin-actions__title">Refresh cost centers</span>
				<span class="admin-actions__description">Pull the latest cost center lists from Open Invoice.</span>
			</div>
			@if (ccRefreshLoading) {
				<app-embark-spinner
					size="2"
					strokeWidth="4"></app-embark-spinner>
			} @else {
				<p-button
					label="Run"
					severity="secondary"
					size="small"
					[outlined]="true"
					(onClick)="refreshCostCenters()"/>
			}
		</div>

		<div class="admin-actions__row">
			<i class="pi pi-file-check admin-actions__icon"></i>
			<div class="admin-actions__text">
				<span class="admin-actions__title">Refresh AFEs</span>
				<span class="admin-actions__description">
                    Pull the latest AFE lists from Open Invoice.
                </span>
			</div>
			@if (afeRefreshLoading) {
				<app-embark-spinner
					size="2"
					strokeWidth="4"></app-embark-spinner>
			} @else {
				<p-button
					label="Run"
					severity="secondary"
					size="small"
					[outlined]="true"
					(onClick)="refreshAfes()"/>
			}
		</div>

		<div class="admin-actions__row">
			<i class="pi pi-building admin-actions__icon"></i>
			<div class="admin-actions__text">
				<span class="admin-actions__title">Refresh buyer site departments</span>
				<span class="admin-actions__description">Sync buyer site department mappings from Open Invoice.</span>
			</div>
			@if (siteRefreshLoading) {
				<app-embark-spinner
					size="2"
					strokeWidth="4"></app-embark-spinner>
			} @else {
				<p-button
					label="Run"
					severity="secondary"
					size="small"
					[outlined]="true"
					(onClick)="refreshBuyerSiteDepartments()"/>
			}
		</div>

		<div class="admin-actions__row">
			<i class="pi pi-sitemap admin-actions__icon"></i>
			<div class="admin-actions__text">
				<span class="admin-actions__title">Refresh requisitioners</span>
				<span class="admin-actions__description">Pull the latest requisitioner lists from Open Invoice.</span>
			</div>
			@if (refreshRequisitionerLoading) {
				<app-embark-spinner
					size="2"
					strokeWidth="4"></app-embark-spinner>
			} @else {
				<p-button
					label="Run"
					severity="secondary"
					size="small"
					[outlined]="true"
					(onClick)="refreshRequisitioners()"/>
			}
		</div>
	</div>

	<p-divider
		align="left"
		styleClass="admin-actions__divider">
		<span class="admin-actions__section-label">Sync from Database</span>
	</p-divider>

	<div class="admin-actions__list">
		<div class="admin-actions__row">
			<i class="pi pi-users admin-actions__icon"></i>
			<div class="admin-actions__text">
				<span class="admin-actions__title">Refresh buyers</span>
				<span class="admin-actions__description">Update buyers to reflect application database records.</span>
			</div>
			@if (buyerRefreshLoading) {
				<app-embark-spinner
					size="2"
					strokeWidth="4"></app-embark-spinner>
			} @else {
				<p-button
					label="Run"
					severity="secondary"
					size="small"
					[outlined]="true"
					(onClick)="refreshBuyers()"/>
			}
		</div>
	</div>

	<p-divider
		align="left"
		styleClass="admin-actions__divider">
		<span class="admin-actions__section-label">Sales orders</span>
	</p-divider>

	<div class="admin-actions__list">
		<div class="admin-actions__row">
			<i class="pi pi-list-check admin-actions__icon"></i>
			<div class="admin-actions__text">
				<span class="admin-actions__title">Run SO gap monitor</span>
				<span class="admin-actions__description">
					Create NetSuite tasks for missing information on sales orders for buyers with the monitor enabled.
				</span>
			</div>
			@if (soGapMonitorLoading) {
				<app-embark-spinner
					size="2"
					strokeWidth="4"></app-embark-spinner>
			} @else {
				<p-button
					label="Run"
					severity="secondary"
					size="small"
					[outlined]="true"
					(onClick)="runSalesOrderGapMonitor()"/>
			}
		</div>
	</div>

	<p-divider
		align="left"
		styleClass="admin-actions__divider">
		<span class="admin-actions__section-label">Buyer migration</span>
	</p-divider>

	<div class="admin-actions__list">
		<div class="admin-actions__row">
			<i class="pi pi-arrow-right-arrow-left admin-actions__icon"></i>
			<div class="admin-actions__text">
				<span class="admin-actions__title">Migrate buyer</span>
				<span class="admin-actions__description">
                    Re-syncs the last year of invoices and tickets for a buyer, updating their statuses in NetSuite.
                </span>
			</div>
			@if (buyerMigrationLoading) {
				<app-embark-spinner
					size="3"
					strokeWidth="4"></app-embark-spinner>
			} @else {
				<p-button
					label="Migrate…"
					severity="warn"
					size="small"
					(onClick)="buyerMigrationConfirmation()"/>
			}
		</div>
	</div>
</div>
